import { render } from "./AnimationsSweetTransitionsSweetChild.vue?vue&type=template&id=dcf2df18&scoped=true&ts=true"
import script from "./AnimationsSweetTransitionsSweetChild.vue?vue&type=script&lang=ts"
export * from "./AnimationsSweetTransitionsSweetChild.vue?vue&type=script&lang=ts"

import "./AnimationsSweetTransitionsSweetChild.vue?vue&type=style&index=0&id=dcf2df18&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf2df18"]])

export default __exports__